import { graphQLSubscriptionDetailDAO } from "./GraphQLSubscriptionDetailDAO";
import { useQuery } from "react-query";
import { useUser } from "../../../components/user/UserContext";

export const useSubscriptionDetails = () => {
    const { user } = useUser();
    const { data: subscriptionDetail, status: getSubscriptionDetailStatus } = useQuery({
        queryKey: ["subscriptionDetail", user.getUsername()],
        queryFn: async () => {
            return await graphQLSubscriptionDetailDAO.getSubscriptionDetails();
        }
    });
    return { subscriptionDetail, getSubscriptionDetailStatus };
};